<script>
import Step from "./elements/Step.vue";
import {isSet, getInfo} from "../scripts/tools.js";

const steps = [
  'Выберите ваш текущий уровень образования',
  'Выберите желаемый уровень подготовки',
  'Выберите интересное Вам направление',
  'Выберите интересное Вам направление подготовки'
];

const objData = [
  {
    'id': 1,
    'name': 'Среднее общее (11 классов) или среднее профессиональное',
    'src': 'vite.svg'
  },
  // {
  //   'id': 2,
  //   'name': 'Основное общее (9 классов)'
  // },
  {
    'id': 3,
    'name': 'Высшее (бакалавриат)',
    'src': 'vite.svg'
  },
  {
    'id': 4,
    'name': 'Высшее (специалитет)',
    'src': 'vite.svg'
  },
  {
    'id': 5,
    'name': 'Высшее (магистратура)'
  },
  {
    'id': 6,
    'name': 'test',
    'show-filter': true,
    'children': [
      {
        'id': 7,
        'name': 'test-children_test-1',
      },
      {
        'id': 8,
        'name': 'test-children_test-2',
        'show-filter': true,
        'children': [
          {
            'id': 10,
            'name': 'test-children_test-2-1',
          },
          {
            'id': 11,
            'name': 'test-children_test-2-2',
            'items': [
              {
                'id': 12,
                'name': 'test-link-1',
                'code': '88.22.33',
                'url': '/test1/',
                'src': 'vite.svg'
              },
              {
                'id': 13,
                'name': 'test-link-2 test-link-2 test-link-2 test-link-2 test-link-2 test-link-2',
                'code': '66.22.33',
                'url': '/test2/',
              },
              {
                'id': 14,
                'name': 'test-link-3',
                'code': '11.22.44',
                'url': '/test3/',
              },
              {
                'id': 15,
                'name': 'test-link-4',
                'code': '11.22.133',
                'url': '/test4/',
              },
              {
                'id': 16,
                'name': 'test-link-5',
                'code': '11.22.333',
                'url': '/test5/',
              },
              {
                'id': 17,
                'name': 'test-link-6 test-link-6 test-link-6 test-link-6 test-link-6',
                'code': '11.222.33',
              },
            ]
          },
        ]
      },
      {
        'id': 9,
        'name': 'test-children_test-3',
      },
    ]
  },
];

export default {
  name: 'Calculator',
  components: {Step},
  data() {
    return {
      steps: [],
      items: {},
      stepData: {},
      currentStep: 1
    }
  },
  methods: {
    getStepItems(step){
      let result = [];
      if(step === 0){
        result = this.items;
      }else if(isSet(this.stepData[step])){
        if(isSet(this.stepData[step].children)){
          result = this.stepData[step].children;
        }else if(isSet(this.stepData[step].items)){
          result = this.stepData[step].items;
          this.stepData[step]['link-step'] = true;
        }
      }

      return result;
    },
    isShowFilterStep(step){
      if(isSet(this.stepData[step]) && isSet(this.stepData[step]['show-filter'])){
        return this.stepData[step]['show-filter'];
      }

      return false;
    },
    isLinkBlock(step){
      if(isSet(this.stepData[step]) && isSet(this.stepData[step]['link-step'])){
        return this.stepData[step]['link-step'];
      }

      return false;
    },
    isSelector(step){
      return !this.isLinkBlock(step)
    },
    scrollToUp(element = null){
      if(element === null){
        this.$refs.calculator.scrollIntoView({behavior: 'smooth'})
      }else{
        element.scrollIntoView({behavior: 'smooth'})
      }
    },
    changeStep(){
      if(isSet(this.$refs['steps'][this.currentStep-1])){
        this.$nextTick(() => {
          this.scrollToUp(this.$refs['steps'][this.currentStep-1].$el)
        });
      }
    },
  },
  async created() {
    //TODO: Убрать из финальной сборки
    if(appBuild === 'prod'){
      let info = await getInfo('steps-data');

      if(isSet(info.data)){
        this.items = info.data;
      }

      if(isSet(info.steps)){
        this.steps = info.steps;

        for(let index in this.steps){
          this.stepData[index] = {};
        }
      }
    }else{
      this.items = objData;
      this.steps = steps;
      for(let index in this.steps){
        this.stepData[index] = {};
      }
    }
  },
  mounted() {
  }
}

</script>

<template>
  <div class="selection-calculator" ref="calculator">
    <Step
        v-for="(item, index) in steps"
        v-model="stepData[index+1]"
        v-model:currentStep="currentStep"
        :show-filter-block="isShowFilterStep(index)"
        :show-link-step="isLinkBlock(index)"
        :show-selector="isSelector(index)"
        :items="getStepItems(index)"
        :step="index+1"
        :key="'step-'+index"
        ref="steps"
        @change-step="changeStep"
    >
      {{item}}
    </Step>
  </div>

</template>

<style lang="scss" scoped>
  .selection-calculator {
    margin: 40px 0;
  }
</style>